module.exports = __webpack_public_path__ + "static/media/jiro.cdd07d4d.png";